import { exportServiceRequestFormResponses } from '@commenda/api';
import { useToggle } from '@commenda/kakashi';
import { useNotification } from '../../hooks/useNotification';

type UseExportFormResponsesParams = {
  serviceRequestId?: string | null;
  /** Exports a single form step; omit to export every form step of the request. */
  taskId?: number;
  entityName?: string | null;
  title?: string | null;
};

export const useExportFormResponses = ({
  serviceRequestId,
  taskId,
  entityName,
  title,
}: UseExportFormResponsesParams) => {
  const { setNotification } = useNotification();
  const isExporting = useToggle(false);

  const exportPdf = async () => {
    if (!serviceRequestId || isExporting.value) return;
    isExporting.on();
    try {
      await exportServiceRequestFormResponses({
        serviceRequestId,
        taskId,
        entityName,
        title,
      });
    } catch (error) {
      setNotification({
        show: true,
        valid: false,
        title: 'Export failed',
        message:
          error instanceof Error
            ? error.message
            : 'Could not export the form responses. Please try again.',
      });
    } finally {
      isExporting.off();
    }
  };

  return { exportPdf, isExporting: isExporting.value };
};
